import { useSelector, useDispatch } from 'react-redux';
import { useCallback, memo } from 'react';
import FJActionTextToImage from '../../../redux/action/FJActionTextToImage';
import useLocalStore from '../../../hooks/useLocalStore';
import FJMobileTextToImageInput from './FJMobileTextToImageInput';
import { setMobileFooterModalData } from '../../../redux/slices/FJSliceModals';

const FJMobileTextToImageInputContainer = memo(function FJMobileTextToImageInputContainer() {
    useLocalStore();
    const dispatch = useDispatch();
    const prompt = useSelector(state => state.textToImage.prompt);
    const promptStatus = useSelector(state => state.textToImage.promptStatus);

    const changePrompt = useCallback(
        prompt => {
            dispatch(FJActionTextToImage.changePromptAction(prompt));
        },
        [dispatch],
    );

    const getInspire = useCallback(() => {
        dispatch(FJActionTextToImage.getInspireAction());
    }, [dispatch]);

    const aiOptimizing = useCallback(() => {
        dispatch(FJActionTextToImage.aiOptimizingAction());
    }, [dispatch]);
    const useImageAsPrompt = file => {
        dispatch(FJActionTextToImage.useImageAsPromptAction(file));
    };
    const showFooterModal = data => {
        dispatch(setMobileFooterModalData({ ...data, display: true }));
    };
    return (
        <FJMobileTextToImageInput
            prompt={prompt}
            changePrompt={changePrompt}
            promptStatus={promptStatus}
            getInspire={getInspire}
            aiOptimizing={aiOptimizing}
            useImageAsPrompt={useImageAsPrompt}
            showFooterModal={showFooterModal}
        />
    );
});

export default FJMobileTextToImageInputContainer;
